module.exports = __webpack_public_path__ + "img/agenda-free-no-background.70833f77.png";